import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'shc-product-preview',
  templateUrl: './product-preview.page.html',
  styleUrls: ['./product-preview.page.scss'],
})
export class ProductPreviewPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
